import type { SearchBarMobileProps } from "@/types/layout-type";
import { Search } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams, useSearchParams } from "react-router-dom";

export default function SearchBarMobile({
    scrolled,
    handleSearch,
}: SearchBarMobileProps) {
    const { t } = useTranslation();
    const { lang } = useParams();
    const [searchParams] = useSearchParams();
    const baseRoute = `/${lang || "id"}`;
    const location = useLocation();
    const searchParamValue = searchParams.get("search") || "";
    const [prevSearchParam, setPrevSearchParam] = useState(searchParamValue);
    const [search, setSearch] = useState(searchParamValue);

    if (searchParamValue !== prevSearchParam) {
        setPrevSearchParam(searchParamValue);
        setSearch(searchParamValue);
    }

    const isAllowedPathSearch =
        location.pathname === `${baseRoute}` ||
        location.pathname === `${baseRoute}/shop`;

    return (
        <div
            className={`md:hidden px-4 py-2 bg-white/90 dark:bg-dark/90 backdrop-blur-md border-b border-gray-100 dark:border-dark-2 transition-all duration-300 pointer-events-auto ${
                !isAllowedPathSearch
                    ? "hidden"
                    : scrolled
                      ? "opacity-0 -translate-y-4 pointer-events-none"
                      : "opacity-100 translate-y-0"
            }`}>
            <div className="w-full flex">
                <input
                    name="search-mobile"
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSearch(search);
                        }
                    }}
                    placeholder={t("nav.search_placeholder")}
                    className="flex-1 px-4 py-2 bg-gray-50 dark:bg-dark border border-gray-200 dark:border-dark-2 rounded-l-full outline-none text-sm focus:border-gold transition-colors dark:text-white"
                />
                <button
                    aria-label="Cari"
                    onClick={() => handleSearch(search)}
                    className="px-5 py-2 bg-surface dark:bg-dark-2 border border-surface dark:border-dark-2 rounded-r-full text-gold">
                    <Search size={18} />
                </button>
            </div>
        </div>
    );
}
